<template>
  <div
    class="newImage"
    :class="{
      'newImage--centerImage': centerImage,
      'newImage--fit': fit,
      'newImage--fitContainCenter': fitContainCenter,
      'newImage--displayImage': displayImage,
    }"
    :style="wrapperStyle"
  >
    <img
      ref="img"
      :class="['newImage__image']"
      :src="parseSrc"
      :width="width"
      :height="height"
      :alt="alt"
      :loading="loading"
    />
  </div>
</template>

<script>
import ImagePlaceholder from '@/components/ImagePlaceholder';

export default {
  name: 'NewImageBox',
  components: { ImagePlaceholder },
  props: {
    loading: {
      type: String,
      default: 'lazy',
    },
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: null,
    },
    width: {
      type: Number,
      default: null,
    },
    maxWidth: {
      type: Number,
      default: null,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    fitContainCenter: {
      type: Boolean,
      default: false,
    },
    centerImage: {
      type: Boolean,
      default: false,
    },
    imageParams: {
      type: String,
      default: 'w_250,h_250',
    },
    displayImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parseSrc() {
      return this.$helper.optimizeImageUrl(this.src, this.imageParams);
    },
    aspectRatio() {
      // Calculate the aspect ratio of the image
      // if the width and the height are given.
      if (!this.width || !this.height) return null;

      return (this.height / this.width) * 100;
    },
    wrapperStyle() {
      const style = {};
      if (this.maxWidth) style.maxWidth = `${this.maxWidth}px`;

      return style;
    },
    style() {
      const style = {};

      if (this.backgroundColor) style.backgroundColor = this.backgroundColor;

      const applyAspectRatio = this.loading && this.aspectRatio;
      if (applyAspectRatio) {
        style.height = 0;
        style.paddingTop = `${this.aspectRatio}%`;
      }

      return style;
    },
  },
};
</script>

<style lang="scss">
// Responsive image styles.

.newImage {
  $root: &;
  position: relative;
  margin: 0 auto;

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    background-color: $cBg;
  }

  &__loaderPlaceholder {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
    opacity: 1;
    transition: opacity $tr;
  }

  &--fit {
    height: 100%;

    #{$root}__image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &--fitContainCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    #{$root}__image {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }

  &--centerImage {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    #{$root}__image {
      height: auto;
      width: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  &--displayImage {
    #{$root}__image {
      position: relative;
    }

    #{$root}__loader {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
